import React, { useState } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import { connect } from "react-redux";
import { getDarkMode } from "../../../store/mode";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "../../../api/authApiSlices";

function mapStateToProps(state) {
  return {
    darkMode: getDarkMode(state),
  };
}

const RecoverPassword = (props) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [forgotPassword] = useForgotPasswordMutation();

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setMessage("");

    await forgotPassword(email)
      .unwrap()
      .then((res) => {
        setMessage("Password reset email sent! Please check your inbox.");
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 3000);
      })
      .catch((error) => {
        setError(error?.data?.message || "Failed to send reset email. Please try again.");
        console.error("Error sending reset email:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <section className="login-content">
        <Container className="h-100">
          <Row className="align-items-center justify-content-center h-100">
            <Col md="5">
              <Card className="p-5">
                  <Card.Body>
                    <h3 className="mb-3 text-center">Reset Password</h3>
                    <p className="text-center small text-secondary mb-3">
                      Please enter your email below
                    </p>
                    {message && (
                      <div className="alert alert-success text-center" role="alert">
                        {message}
                      </div>
                    )}
                    {error && (
                      <div className="alert alert-danger text-center" role="alert">
                        {error}
                      </div>
                    )}
                    <Form onSubmit={onSubmit}>
                      <Row>
                        <Col lg="12">
                          <Form.Group>
                            <Form.Label className="text-secondary">
                              Email
                            </Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Enter Email"
                              required
                              value={email}
                              onChange={(e) =>
                                setEmail(e.target.value)
                              }
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                        {isLoading ? "Sending..." : "Send Recovery Email"}
                      </Button>
                    </Form>
                  </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default connect(mapStateToProps)(RecoverPassword);
